import React from 'react'
import {Field} from 'formik'
import {useIntl} from 'react-intl'

import {
  CustomSelect,
  DatePicker
} from '@/components/form'

const now = new Date()
const initialFilters = {
  status: 'SUCCEED',
  from: new Date([
    now.getFullYear(),
    (now.getMonth() + 1).toString().padStart(2, '0'),
    '01'
  ].join('-'))
}

const statuses = [
  'SUCCEED',
  'PENDING',
  'CANCELLED',
]

const FilterForm = () => {
  const intl = useIntl()
  return (
    <>
      <Field
        component={DatePicker}
        label='From'
        name="from"
        id="from"
        required={true}
        options={{
          dateFormat: "Y-m-d",
          maxDate: now
        }}
      />

      <Field
        component={DatePicker}
        label='To'
        name="to"
        options={{
          dateFormat: "Y-m-d",
          maxDate: now
        }}
      />

      <Field
        default="Select status"
        component={CustomSelect}
        label="Status"
        name="status"
        options={statuses.map((s:string) => {
          return { value: s, label: intl.formatMessage({id: `P2C.ORDER_STATUS_${s}`})}
        })}
      />
    </>
  )
}

export {FilterForm, initialFilters}
